// =============================================================================
// Reaction Repository - CRUD pour les réactions chat
// =============================================================================

import { supabase } from '@/integrations/supabase/client';

export async function addReaction(messageId: string, memberId: string, emoji: string): Promise<void> {
  const { error } = await supabase
    .from('chat_reactions')
    .insert({ message_id: messageId, org_member_id: memberId, emoji });

  if (error && error.code !== '23505') throw error; // Ignore duplicate
}

export async function removeReaction(messageId: string, memberId: string, emoji: string): Promise<void> {
  const { error } = await supabase
    .from('chat_reactions')
    .delete()
    .eq('message_id', messageId)
    .eq('org_member_id', memberId)
    .eq('emoji', emoji);

  if (error) throw error;
}

export async function toggleReaction(messageId: string, memberId: string, emoji: string): Promise<void> {
  // Check if reaction exists
  const { data } = await supabase
    .from('chat_reactions')
    .select('id')
    .eq('message_id', messageId)
    .eq('org_member_id', memberId)
    .eq('emoji', emoji)
    .maybeSingle();

  if (data) {
    await removeReaction(messageId, memberId, emoji);
  } else {
    await addReaction(messageId, memberId, emoji);
  }
}
